module.exports = __webpack_public_path__ + "static/media/shapes-square-line.bdec13a5.svg";